import initialState from "../../../store/initialState";
import * as TenantManagementTypes from "../services/TenantManagementActionType";

const types = { ...TenantManagementTypes };

const tenantManagementReducer = (
  state = initialState.tenantManagementReducer,
  action,
) => {
  switch (action.type) {
    case types.TENANTMANAGEMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.TENANTMANAGEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        TenantManagement: action.payload,
        error: null,
      };
    case types.TENANTMANAGEMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case types.GET_TENANT_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.GET_TENANT_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tenantDetails: action.payload,
        error: null,
      };
    case types.GET_TENANT_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case types.GET_ALL_MASTER_TENANT_TYPES_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.GET_ALL_MASTER_TENANT_TYPES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        masterTenantTypes: action.payload,
        error: null,
      };
    case types.GET_ALL_MASTER_TENANT_TYPES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case types.SAVE_TENANT_REQUEST:
      return {
        ...state,
        isLoadingsave: true,
        saveSuccess: false,
        error: null,
      };

    case types.SAVE_TENANT_SUCCESS:
      return {
        ...state,
        isLoadingsave: false,
        savetenantDetails: action.payload.success,
        saveSuccess: true,
        error: null,
      };

    case types.SAVE_TENANT_FAILURE:
      return {
        ...state,
        isLoadingsave: false,
        saveSuccess: false,
        error: action.payload,
      };

    case types.GET_STORAGE_CATEGORY_DROPDOWN_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.GET_STORAGE_CATEGORY_DROPDOWN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        storageCategoryDropdown: action.payload,
        error: null,
      };
    case types.GET_STORAGE_CATEGORY_DROPDOWN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case types.GET_ALL_MASTER_COUNTRY_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.GET_ALL_MASTER_COUNTRY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        masterCountryDropdowns: action.payload,
        error: null,
      };
    case types.GET_ALL_MASTER_COUNTRY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case types.GET_ALL_MASTER_TIMEZONE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.GET_ALL_MASTER_TIMEZONE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        masterTimeZoneDropdowns: action.payload,
        error: null,
      };
    case types.GET_ALL_MASTER_TIMEZONE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case types.ACTIVATE_DEACTIVATE_TENANT_REQUEST:
      return {
        ...state,
        isLoadingActivateDeactivate: true,
        error: null,
      };
    case types.ACTIVATE_DEACTIVATE_TENANT_SUCCESS:
      return {
        ...state,
        isLoadingActivateDeactivate: false,
        activateDeactivateResponse: action.payload,
        error: null,
      };
    case types.ACTIVATE_DEACTIVATE_TENANT_FAILURE:
      return {
        ...state,
        isLoadingActivateDeactivate: false,
        error: action.payload,
      };

    case types.DELETE_TENANT_REQUEST:
      return {
        ...state,
        isLoadingActivateDeactivate: true,
        error: null,
      };
    case types.DELETE_TENANT_SUCCESS:
      return {
        ...state,
        isLoadingActivateDeactivate: false,
        deleteTenantResponse: action.payload,
        error: null,
      };
    case types.DELETE_TENANT_FAILURE:
      return {
        ...state,
        isLoadingActivateDeactivate: false,
        error: action.payload,
      };

    case types.GET_DEFAULT_TENANT_CONFIG_REQUEST:
      return {
        ...state,
        isLoadingDefaultTenantConfig: true,
        defaultTenantConfig: null,
        error: null,
      };
    case types.GET_DEFAULT_TENANT_CONFIG_SUCCESS:
      return {
        ...state,
        isLoadingDefaultTenantConfig: false,
        defaultTenantConfig: action.payload,
        error: null,
      };
    case types.GET_DEFAULT_TENANT_CONFIG_FAILURE:
      return {
        ...state,
        isLoadingDefaultTenantConfig: false,
        error: action.payload,
      };

    case types.SAVE_DEFAULT_TENANT_CONFIG_REQUEST:
      return {
        ...state,
        isSavingDefaultTenantConfig: true,
        saveDefaultTenantConfigSuccess: false,
        error: null,
      };
    case types.SAVE_DEFAULT_TENANT_CONFIG_SUCCESS:
      return {
        ...state,
        isSavingDefaultTenantConfig: false,
        saveDefaultTenantConfigSuccess: true,
        error: null,
      };
    case types.SAVE_DEFAULT_TENANT_CONFIG_FAILURE:
      return {
        ...state,
        isSavingDefaultTenantConfig: false,
        saveDefaultTenantConfigSuccess: false,
        error: action.payload,
      };

    case types.RESET_DEFAULT_TENANT_CONFIG:
      return {
        ...state,
        defaultTenantConfig: null,
        isLoadingDefaultTenantConfig: false,
        isSavingDefaultTenantConfig: false,
        saveDefaultTenantConfigSuccess: false,
      };

    default:
      return state;
  }
};
export default tenantManagementReducer;
